import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pqImageTitleFormat',
    standalone: false
})
export class ImageTitleFormatPipe implements PipeTransform {
  public transform (text: string) {

    return text ? text.replace('Description: ', '').trim() : '';
  }
}
